module.exports = __webpack_public_path__ + "img/turbo_on.2fd70b58.png";